import React from 'react'
import { withTranslation } from 'react-i18next'

import DonutChart from './DonutChart'
import { COLOR_PALETTES } from 'app/constants/colorPalletes'

import './styles.scss'

const bc = 'company-dashboard-protracks'

const CompanyDashboardProTracks = ({ t, proTracks }) => {
  if (!proTracks) {
    return null
  }
  const chartData = proTracks.map(proTrack => proTrack.percentage)
  const chartDataColorsNames = proTracks.map(({ name }, index) => ({
    color: COLOR_PALETTES[index] || COLOR_PALETTES[Math.floor(Math.random() * COLOR_PALETTES.length)],
    name,
  }))
  const renderProtrackLists = () => {
    return (
      <ul className={`${bc}__list`}>
        {chartDataColorsNames.map(({ color, name }, i) => (
          <li key={i} className={`${bc}__list-item`}>
            <span style={{ background: color }} />
            {name}
          </li>
        ))}
      </ul>
    )
  }
  return (
    <div className={bc}>
      <div className={`${bc}__chart`}>
        <div className={`${bc}__title`}>{t('How Your Team has Grown')}</div>
        <DonutChart data={chartData} colors={chartDataColorsNames} />
      </div>
      {renderProtrackLists()}
    </div>
  )
}

CompanyDashboardProTracks.displayName = 'CompanyDashboardProTracks'

export default withTranslation('user')(CompanyDashboardProTracks)
